var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { query, where } from 'firebase/firestore';
import { useMemo } from 'react';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import { useJobsCollection } from './use_jobs_collection.hook';
const jobConverter = {
    toFirestore(jobWithId) {
        const job = Object.assign({}, jobWithId);
        delete job.jobId;
        return job;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return Object.assign({ jobId: snapshot.id }, data);
    },
};
export function useJobs(_a = {}) {
    var { type, status } = _a, otherConditions = __rest(_a, ["type", "status"]);
    const { collection, user, loading: loadingJobsCollection, error: errorJobsCollection } = useJobsCollection();
    const _query = useMemo(() => {
        if (!collection) {
            return null;
        }
        const conditions = [where('user', '==', user)];
        if (type) {
            conditions.push(where('type', Array.isArray(type) ? 'in' : '==', type));
        }
        if (status) {
            conditions.push(where('status', Array.isArray(status) ? 'in' : '==', status));
        }
        if (otherConditions) {
            Object.entries(otherConditions).forEach(([key, value]) => conditions.push(where(key, '==', value)));
        }
        return query(collection.withConverter(jobConverter), ...conditions);
    }, [collection, JSON.stringify(type), JSON.stringify(status), JSON.stringify(otherConditions)]);
    const [values, loadingFirestore, errorFirestore] = useCollectionData(_query);
    return {
        isLoading: loadingJobsCollection || loadingFirestore,
        values: values,
        error: errorJobsCollection || errorFirestore,
    };
}
//# sourceMappingURL=use_jobs.hook.js.map